import Header from 'next/head';

import NewOrder from '@/pages/NewOrder';

const NewOrderPage = () => (
  <>
    <Header>
      <title>Buy ClearVPN. Expand and secure online activities with VPN hassle-free.</title>
      <meta
        name="description"
        content="Buy ClearVPN risk-free. Enjoy the full online potential with just a tap. Buy VPN and forget about server-picking."
      />
    </Header>
    <NewOrder excludeWeeklyPlans />
  </>
);

export default NewOrderPage;
